module.exports = __webpack_public_path__ + "img/wp-icon.f93cef86.svg";